import type {ComponentStageData, ComponentStageHeuristicDefinition} from '../../types'
import {getTransformationsPointer} from '../../conversionDal/utils/pointer'
import {updateTransformations} from '../common'

const cancelRotation = (componentStageData: ComponentStageData) => {
    const {componentPointer, conversionDal} = componentStageData
    const transformations = conversionDal.get(getTransformationsPointer(componentPointer))

    if (transformations?.rotate) {
        updateTransformations(componentStageData, {rotate: 0})
    }
}

export const rotationHeuristics: ComponentStageHeuristicDefinition[] = [
    {
        predicate: () => true,
        apply: cancelRotation,
        heuristicCode: 'CANCEL ROTATION'
    }
]
